
import { Button } from "@/components/ui/button";
import { Edit, Trash, Ban } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { toast } from "sonner";
import type { Owner } from "../types";

interface ActionsColumnProps {
  row: Owner;
  onDelete: (userId: string) => Promise<void>;
  onBlockUser: (userId: string, isBlocked: boolean) => Promise<void>;
}

export const ActionsColumn = ({ row, onDelete, onBlockUser }: ActionsColumnProps) => {
  return (
    <div className="flex gap-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => toast.info("Fonctionnalité à venir - Édition")}
      >
        <Edit className="h-4 w-4" />
      </Button>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="ghost" size="icon">
            <Trash className="h-4 w-4 text-destructive" />
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Êtes-vous sûr ?</AlertDialogTitle>
            <AlertDialogDescription>
              Cette action est irréversible. Cela supprimera définitivement le compte de l'utilisateur
              et toutes ses données associées.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuler</AlertDialogCancel>
            <AlertDialogAction 
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
              onClick={() => onDelete(row.id)}
            >
              Supprimer
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onBlockUser(row.id, !row.is_blocked)}
      >
        <Ban className={`h-4 w-4 ${row.is_blocked ? 'text-muted-foreground' : 'text-destructive'}`} />
      </Button>
    </div>
  );
};
